import React from 'react';
import "./SupportPage.scss";
import { Table, Badge, Form, Dropdown, Button } from "react-bootstrap";
import Chaticon from '../../images/logo_icon.png'
import { withTranslation } from "react-i18next";

const SupportPage = ({ t }) => (

  <div className='SupportPage'>
    <div className="List_header">
      <h5 className="MH">{t("Support.key1")}</h5>
    </div>
    <div className='mt-3'>
      <section className='SupportPage_01'>
        <div className='p-2'>
          <h5 className='m-0'>{t("Support.key2")}​</h5>
        </div>
        <div>
          <ul>
            <li>{t("Support.key3")} <span> {t("Support.key4")}</span>?​</li>
            <li>{t("Support.key5")}<span>{t("Support.key6")}</span>. ​</li>
            <li>{t("Support.key7")} <span>{t("Support.key4")}</span>, {t("Support.key8")} <span>{t("Support.key9")}</span> {t("Support.key10")}​</li>
          </ul>
        </div>
      </section>
      <section className='SupportPage_02'>
        <div className='p-2'>
          <h5 className='m-0'>{t("Support.key11")}​</h5>
        </div>
        <div className='row m-0'>
          <div className='col-md-4 p-2'>
            <div className='card'>
              <div className='card-header'>
                <h6 className='m-0'>{t("Support.key12")}</h6>
              </div>
              <div className='card-body'>
                <ul>
                  <li>{t("Support.key13")} <span className='blue_font'>{t("Support.key14")}</span> {t("Support.key15")} <span className='blue_font'>{t("Support.key16")}</span>  {t("Support.key17")}:</li>
                  <li>{t("Support.key18")}</li>
                  <li>{t("Support.key19")}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className='col-md-4 p-2'>
            <div className='card'>
              <div className='card-header'>
                <h6 className='m-0'>{t("Support.key20")}</h6>
              </div>
              <div className='card-body'>
                <ul>
                  <li>{t("Support.key13")} <span className='blue_font'>{t("Support.key21")}</span> {t("Support.key15")} <span className='blue_font'>{t("Support.key16")}</span> {t("Support.key17")}:</li>
                  <li>{t("Support.key22")} <span className='light_greenfont'>{t("Support.key23")}</span> <a target="_blank" href='https://ecodrisil.com/support'><span className='blue_font'>{t("Support.key24")}</span></a></li>
                  <li>{t("Support.key25")}<span className='light_greenfont'>{t("Support.key23")}</span> {t("Support.key26")}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className='col-md-4 p-2'>
            <div className='card'>
              <div className='card-header'>
                <h6 className='m-0'>{t("Support.key27")}​</h6>
              </div>
              <div className='card-body'>
                <ul>
                  <li>{t("Support.key13")}<span className='blue_font'>{t("Support.key28")}</span> {t("Support.key15")} <span className='blue_font'>{t("Support.key16")}</span> {t("Support.key17")}:​​</li>
                  <li>{t("Support.key29")}<span className='light_greenfont'>{t("Support.key23")}</span> 
                    <a target="_blank" href='mailto:support@ecodrisil.com'><span className='blue_font'> {t("Support.key30")}</span></a></li>
                  <li>{t("Support.key31")}</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </section>

      <section className='SupportPage_03'>
        <div className='p-2'>
          <h5 className='m-0'>{t("Support.key32")}​​</h5>
        </div>
        <div>
          <ul>
            <li>{t("Support.key33")}</li>
            <li>{t("Support.key34")}</li>
            <li>{t("Support.key35")}</li>
            <li>{t("Support.key36")}</li>
          </ul>
        </div>
      </section>

      {/* <section className='SupportPage_03'>
        <div className='p-2'>
          <h5 className='m-0'>Service-Level Agreement for Incidents​​​</h5>
        </div>
        <div className='p-2'>
          <div className='card'>
            <Table>
              <thead>
                <tr>
                  <th>Severity Level</th>
                  <th>Incident Priorities</th>
                  <th>Definition</th>
                  <th>Response Time</th>
                  <th>Target Restore time</th>
                  <th>Root Cause Removal Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>P 1</td>
                  <td>High </td>
                  <td>
                    <p>An incident should be categorized as “High” priority when the issue has serious consequences on your business processes. Urgent work cannot be performed.</p>
                    <p className='mb-2'><b>For example:</b></p>
                    <ul>
                      <li>A productive system is completely down.</li>
                      <li>The customer's core business or IT processes are seriously affected.</li>
                      <li>No workaround is available.</li>
                    </ul>
                    <p> The incident requires immediate processing because the malfunction may cause serious losses.</p>
                  </td>
                  <td>4  hours​</td>
                  <td>24 hours​</td>
                  <td>Work 24/7 to provide a fix or work-around</td>
                </tr>
                <tr>
                  <td>P 2</td>
                  <td>Medium</td>
                  <td>
                    <p>An incident should be categorized as “Medium” priority when the business processes are seriously affected. Essential tasks which are urgent cannot be performed due to an issue with the product.</p>
                    <p className='mb-2'><b>For example;</b></p>
                    <ul>
                      <li> Many users are unable to access the system</li>
                      <li>No workaround is not available.</li>
                    </ul>
                    <p>The incident is to be processed as quickly as possible because a continuing malfunction can seriously disrupt the entire productive business flow.</p>
                  </td>
                  <td>24 hours</td>
                  <td>72 hours</td>
                  <td>Provide a fix, work-around, or action plan within 5 business days​</td>
                </tr>
                <tr>
                  <td>P 3</td>
                  <td>Low</td>
                  <td> An incident should be categorized as “Low” if the issue has little or no effect on normal business processes. The problem is caused by an issue with the product that are not required daily or are rarely used.​</td>
                  <td>48 hours</td>
                  <td>5 business days</td>
                  <td>Provide a fix, work-around or action plan within 10 business days or with the next scheduled release​</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </section> */}

      <section className='SupportPage_03'>
        <div className='p-2'>
          <h5 className='m-0'>{t("Support.key37")}</h5>
        </div>
        <div className='p-2'>
          <p>{t("Support.key38")} :- <a target="_blank" href='https://ecodrisil.com/support'>https://ecodrisil.com/support</a></p>
          <p>{t("Support.key12")} :- <a target="_blank" href='https://ecodrisil.com/support'>https://ecodrisil.com/support</a></p>
          <p>{t("Support.key39")} <a target="_blank" href='mailto:support@ecodrisil.com'>support@ecodrisil.com</a></p>
        </div>
      </section>

    </div>

    <div tooltip="Chat" className="AllChatbox_Btn">
      <a target="_blank" href='https://ecodrisil.com/support'>
        <div className="AllChatFloatingBox">
          <img src={Chaticon} />
        </div>
      </a>
    </div>
  </div>
);

export default withTranslation()(SupportPage);